import FileSaver from 'file-saver'

export const useFileUtil = {
  /**
   * 下载
   */
  download: (url, name) => {
    FileSaver.saveAs(url, name)
  },

  /**
   * excel文件导出
   */
  excelExport: (res, suffix = 'xlsx', type = 'application/vnd.ms-excel;charset=utf-8') => {
    const blob = new Blob([res], { type })
    const filename = `${new Date().getTime()}.${suffix}`
    const a = document.createElement('a')
    const url = window.URL.createObjectURL(blob)
    a.href = url
    a.download = filename
    const body = document.getElementsByTagName('body')[0]
    body.appendChild(a)
    a.click()
    body.removeChild(a)
    window.URL.revokeObjectURL(url)
  },

  /**
   * 根据文件后缀获取文件类型列表
   */
  suffixToTypeList: suffixList => {
    return suffixList.map(suffix => useFileUtil.suffixToType(suffix))
  },

  /**
   * 根据文件后缀获取文件类型
   */
  suffixToType: suffix => {
    const names = suffix.toLowerCase().split('.')
    switch (names[names.length - 1]) {
      case 'png':
        return 'image/png'
      case 'jpg':
        return 'image/jpeg'
      case 'jpeg':
        return 'image/jpeg'
      case 'pdf':
        return 'application/pdf'
      case 'gif':
        return 'image/gif'
      case 'bmp':
        return 'image/bmp'
      case 'svg':
        return 'image/svg+xml'
      case 'webp':
        return 'image/webp'
      case 'doc':
        return 'application/msword'
      case 'docx':
        return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      case 'xls':
        return 'application/vnd.ms-excel'
      case 'xlsx':
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      case 'ppt':
        return 'application/vnd.ms-powerpoint'
      case 'pptx':
        return 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
      case 'txt':
        return 'text/plain'
      case 'csv':
        return 'text/csv'
      case 'html':
        return 'text/html'
      case 'xml':
        return 'application/xml'
      case 'json':
        return 'application/json'
      case 'zip':
        return 'application/zip'
      case 'rar':
        return 'application/x-rar-compressed'
      case 'mp3':
        return 'audio/mpeg'
      case 'mp4':
        return 'video/mp4'
      case 'avi':
        return 'video/x-msvideo'
      case 'mov':
        return 'video/quicktime'
      default:
        return 'application/octet-stream'
    }
  },

  /**
   * 判断是否为图片
   */
  isImg: suffix => {
    if (!suffix) return false
    const list = suffix.split('.')
    const sf = list[list.length - 1].toLowerCase()
    const imgFormats = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp', 'svg', 'heic', 'tiff', 'ico']
    return imgFormats.includes(sf)
  }
}
